var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"text-center mt-5 font-2xl text-muted"},[_c('i',{staticClass:"fal fa-spinner fa-spin"}),_vm._v(" Test Package Table Data Loading...\n")]):_c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{attrs:{"title":"Projects","active":""}},[_c('h3',[_vm._v("Projects")]),_c('project-server-table',{attrs:{"sample_types":_vm.sample_type_collection,"test_packages":_vm.test_package_collection,"show_columns":[
          'pid',
          'customer.full_name',
          'customer_contact',
          'customer_location',
          'sample_types',
          'test_packages',
          'turnarounds',
          'submission_count',
          'created_at',
          'received_percent',
          'prepped_percent',
          'scheduled_percent',
          'results_percent'
        ]}})],1),_c('b-tab',{attrs:{"title":"Submissions"}},[_c('h3',[_vm._v("Submissions")]),_c('submission-server-table',{attrs:{"analytes":_vm.analyte_collection,"sample_types":_vm.sample_type_collection,"test_packages":_vm.test_package_collection,"show_columns":[
          'pid',
          'project.pid',
          'event_code',
          'project.customer.full_name',
          'sample_type.name',
          'test_package.name',
          'sample_count',
          'created_at',
          'received_percent',
          'prepped_percent',
          'scheduled_percent',
          'results_percent'
        ]}})],1),_c('b-tab',{attrs:{"title":"Samples"}},[_c('h3',[_vm._v("Samples")]),_c('sample-server-table',{attrs:{"analytes":_vm.analyte_collection,"sample_types":_vm.sample_type_collection,"test_packages":_vm.test_package_collection,"show_columns":[
          'pid',
          'receiving_id',
          'submission.pid',
          'submission.project.customer.full_name',
          'identifier',
          'number',
          'created_at',
          'received',
          'prepped',
          'scheduled'
        ]}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }